// Enum types used by database
export var AgentType;
(function (AgentType) {
    AgentType["EXTRACTOR"] = "EXTRACTOR";
    AgentType["COMPARATOR"] = "COMPARATOR";
    AgentType["VALIDATOR"] = "VALIDATOR";
    AgentType["CLEANER"] = "CLEANER";
    AgentType["DUPLICATOR"] = "DUPLICATOR";
    AgentType["SPECIFIC_FIELD"] = "SPECIFIC_FIELD";
})(AgentType || (AgentType = {}));
export var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel || (LogLevel = {}));
export var ProposalType;
(function (ProposalType) {
    ProposalType["NEW_EVENT"] = "NEW_EVENT";
    ProposalType["EVENT_UPDATE"] = "EVENT_UPDATE";
    ProposalType["EDITION_UPDATE"] = "EDITION_UPDATE";
    ProposalType["RACE_UPDATE"] = "RACE_UPDATE";
    ProposalType["EVENT_MERGE"] = "EVENT_MERGE";
})(ProposalType || (ProposalType = {}));
//# sourceMappingURL=database.js.map